var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.08317 10.0003C2.91789 10.0003 2.77935 9.94442 2.66755 9.83262C2.55574 9.72081 2.49984 9.58227 2.49984 9.41699V8.25033H10.0832V3.00033H11.2498C11.4151 3.00033 11.5537 3.05623 11.6655 3.16803C11.7773 3.27984 11.8332 3.41838 11.8332 3.58366V12.3337L9.49984 10.0003H3.08317ZM0.166504 9.41699V1.25033C0.166504 1.08505 0.222407 0.946506 0.334212 0.834701C0.446018 0.722895 0.58456 0.666992 0.749837 0.666992H8.33317C8.49845 0.666992 8.63699 0.722895 8.7488 0.834701C8.8606 0.946506 8.9165 1.08505 8.9165 1.25033V6.50033C8.9165 6.6656 8.8606 6.80415 8.7488 6.91595C8.63699 7.02776 8.49845 7.08366 8.33317 7.08366H2.49984L0.166504 9.41699Z",
    fill: "#3B82F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSummary);
export default __webpack_public_path__ + "static/media/icon_summary.df3cceb146587b5e73aa73956a93cf46.svg";
export { ForwardRef as ReactComponent };